declare global {
    interface Window {
        /** Matomo's command queue, defined by matomo.js once the container's Matomo tag has loaded it. */
        _paq?: { push: (...commands: unknown[][]) => unknown };
    }
}

const NUMERIC = /^\d+$/;

/**
 * Pushes a Matomo event. Consent is the caller's job. `_paq` only exists once the
 * tracker is loaded, so an earlier event is dropped instead of being queued ahead
 * of the first page view.
 */
function pushEvent(category: string, action: string, name: string): void {
    try {
        window._paq?.push(['trackEvent', category, action, name]);
    } catch {
        // Third-party code: a tracking error must never fail the interaction that triggered it.
    }
}

/** A click on a `mailto:` link, named by the page it happened on. */
export function trackMailtoClick(): void {
    pushEvent('Kontakt', 'E-Mail-Klick', window.location.pathname);
}

/** A form submission the server confirmed, named by the apartment from the `apartmentNumber` URL parameter. */
export function trackFormSubmit(apartmentNumber: string | null): void {
    const apartment = toApartment(apartmentNumber);
    pushEvent('Formular', 'Absenden', apartment ? `Wohnung ${apartment}` : 'Kontakt allgemein');
}

/** Only a purely numeric value counts as an apartment; anything else is a general enquiry. */
function toApartment(value: string | null): string | null {
    const trimmed = value?.trim() ?? '';
    return NUMERIC.test(trimmed) ? trimmed : null;
}
